// Desktop / meta UI texture declarations as plain data (no pixi import), so both
// the game loader (render/assets.ts loadUiTextures) and the studio catalog can
// read the same list. Keys match the UiTextures field names.

const UI_ROOT = '/assets/ui';
const SPARKY_ROOT = '/assets/textures/characters/sparky_bot';

export type UiAssetKey =
  | 'mainBg'
  | 'gameFrame'
  | 'paper'
  | 'enemyCardBody'
  | 'enemyAvatar'
  | 'labelBg'
  | 'selectBtn'
  | 'punchIcon'
  | 'kickIcon'
  | 'border'
  | 'corner';

export type UiAssetDescriptor = { key: UiAssetKey; url: string; label: string };

export const UI_ASSETS: readonly UiAssetDescriptor[] = [
  { key: 'mainBg', url: `${UI_ROOT}/main-bg.png`, label: 'Wrapper' },
  { key: 'gameFrame', url: `${UI_ROOT}/game-section-frame.png`, label: 'Game window' },
  { key: 'paper', url: `${UI_ROOT}/paper.png`, label: 'Paper sheet' },
  { key: 'enemyCardBody', url: `${UI_ROOT}/enemy-card/enemy-card-body.png`, label: 'Enemy card' },
  { key: 'enemyAvatar', url: `${UI_ROOT}/enemy-card/sparky.png`, label: 'Enemy avatar' },
  { key: 'labelBg', url: `${UI_ROOT}/enemy-card/label-bg.png`, label: 'Skill label plate' },
  { key: 'selectBtn', url: `${UI_ROOT}/enemy-card/select-btn-bg.png`, label: 'Button background' },
  { key: 'punchIcon', url: `${SPARKY_ROOT}/punch/ui-log-icon.png`, label: 'Punch icon' },
  { key: 'kickIcon', url: `${SPARKY_ROOT}/kick/ui-log-icon.png`, label: 'Kick icon' },
  { key: 'border', url: `${UI_ROOT}/border.png`, label: 'Modal border' },
  { key: 'corner', url: `${UI_ROOT}/corner.png`, label: 'Modal corner' },
] as const;
